import React, { useCallback, useState } from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { useClientContactsModal } from '../Contacts/useClientContactsModal';

import { ClientWithContactsSearch } from './ClientWithContactsSearch';

export const ClientContacts: React.FC = () => {
  const pok = usePokCore();
  const lang = pok.getLanguage();
  const [refresh, setRefresh] = useState(false);
  const { open, modal } = useClientContactsModal(() => setRefresh(r => !r));

  const getData = useCallback(
    ((
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) =>
      pok.clients.getWithContactsByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        lang,
      )) as GridGetterFunction,
    [pok.clients, lang],
  );

  const getCount = useCallback(
    ((filterText: string, filterColumns: string) =>
      pok.clients.getWithContactsCount(
        filterText,
        filterColumns,
      )) as GridCountFunction,
    [pok.clients],
  );

  return (
    <>
      <ClientWithContactsSearch
        getData={getData}
        getCount={getCount}
        onRowClick={open}
        refresh={refresh}
      />
      {modal}
    </>
  );
};
